export default __webpack_public_path__ + "static/media/181.74c36f11.png";